goog.provide('el8.app.shared.network.unmappedProfileDetails');

goog.require('el8.appchart.providers.tooltips');
goog.require('el8.appservice.notifier');
goog.require('el8.service.urls');
goog.require('el8.template.app.shared.network.profileDetails');
goog.require('el8.uiwidget.alert');
goog.require('el8.uiwidget.collapsible');
goog.require('el8.uiwidget.Form');
goog.require('el8.uiwidget.FormDialog');
goog.require('el8.util.consts');
goog.require('el8.util.smart');
goog.require('el8.util.string');


/**
 *
 */
el8.app.shared.network.unmappedProfileDetails = (function() {

    var contactId = null;
    var callbackFn = null;

    var that = new el8.uiwidget.FormDialog({
        title: 'Profile Details',
        contentFn: el8.template.app.shared.network.profileDetails.unmappedContent,
        width: 416,
        position: 'center',
        autoHeight: true,
        showXButton: true
    });

    var form = new el8.uiwidget.Form({
        fields: [
            {
                //radio
                name: 'contactType',
                selector: ':input[name="contactType"]'
            },
            {
                name: 'firstName',
                selector: ':input[name="firstName"]',
                maxLength: 50,
                infoText: 'First'
            },
            {
                name: 'middleName',
                selector: ':input[name="middleName"]',
                maxLength: 50,
                infoText: 'Middle'
            },
            {
                name: 'lastName',
                selector: ':input[name="lastName"]',
                maxLength: 60,
                infoText: 'Last'
            },
            {
                name: 'credentials',
                selector: ':input[name="credentials"]',
                maxLength: 20,
                mindreaderOpts: {
                    data: el8.util.consts.CONTACT_CREDENTIALS,
                    containerWidth: 280,
                    showOnFocus: true
                },
                infoText: 'Designation (MD, ...)'
            },
            {
                name : 'name',
                selector: ':input[name="name"]',
                maxLength: 100,
                infoText: 'Group name'
            },
            {
                name: 'specialties',
                selector: ':input[name="specialties"]',
                listeditorOpts: function() {
                    var leOpts = el8.appshared.listeditorOpts.medicalSpecialties();
                    return $.extend(leOpts, {
                        list: $('.specialties-list', that.getContentElt()),
                        addEntryFn: function() { that.adjustHeight(); },
                        mindreaderOpts: $.extend(leOpts.mindreaderOpts, {
                            selectFn: function(event, item) {
                                form.getListeditor('specialties').addEntry(item);
                            }
                        })
                    });
                },
                maxLength: 50,
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                infoText: 'Add a specialty...'
            },
            {
                name: 'address',
                selector: ':input[name="address"]',
                maxLength: 200,
                infoText: 'Street'
            },
            {
                name: 'city',
                selector: ':input[name="city"]',
                maxLength: 50,
                infoText: 'City'
            },
            {
                name: 'state',
                selector: ':input[name="state"]',
                maxLength: 2,
                infoText: 'State'
            },
            {
                name: 'zip',
                selector: ':input[name="zip"]',
                maxLength: 10,
                infoText: 'Zip'
            },
            {
                name: 'phone',
                selector: ':input[name="phone"]',
                maxLength: 20,
                validate: {phone: true}
            },
            {
                name: 'fax',
                selector: ':input[name="fax"]',
                maxLength: 20,
                validate: {phone: true}
            },
            {
                name: 'acceptingNewPatients',
                selector: ':input[name="acceptingNewPatients"]'
            },
            {
                // boolean selector
                name: 'acceptingInsurance',
                selector: ':input[name="acceptingInsurance"]'
            },
            {
                // string
                name: 'insuranceAccepted',
                selector: ':input[name="insuranceAccepted"]',
                height: el8.util.consts.XL_FIELD_HEIGHT,
                maxLength: 200
            },
            {
                name: 'email',
                selector: ':input[name="email"]',
                maxLength: 75
            },
            {
                name: 'directAddress',
                selector: ':input[name="directAddress"]',
                maxLength: 75
            },
            {
                name: 'cellPhone',
                selector: ':input[name="cellPhone"]',
                maxLength: 20,
                validate: {phone: true}
            },
            {
                name: 'backOfficePhone',
                selector: ':input[name="backOfficePhone"]',
                maxLength: 20,
                validate: {phone: true}
            },
            {
                name: 'notes',
                selector: ':input[name="notes"]'
            }
        ],
        firstFocusSelector: ':input[name="firstName"]',
        validationOpts: el8.util.validate.standardOpts
    });
    form.addSaveButton(saveFn, true);
    form.addDiscardChangesButton(function() { that.hide(); });
    that.setForm(form);


    var super_init = that._init;
    that._init = function() {
        super_init.call(that);

        that.getContentElt().on('click', '.connection-write-letter-trigger',  function() {
            var id = $(this).data('id');
            el8.appchart.mgr.thirdpane.showLetter({
                type: el8.util.consts.CONSULTANT_LETTER,
                contactId: id,
                clickSource: 'unmapped-profile'
            });
            that.hide();

        }).on('click', '.connection-write-referral-trigger',  function() {
            var id = $(this).data('id');
            el8.appchart.mgr.thirdpane.setReferralLetterContact(id, 'unmapped-profile');

            that.hide();

        }).on('change', ':input[name="contactType"]',  function() {
            showTypeSpecificFields();

        }).on('click', '.delete-trigger',  function() {
            var deleteFn = function() {
                $.el8_ajax({
                    url: el8.service.urls.get('connections', [contactId]),
                    type: 'DELETE',
                    success: function() {
                        if (callbackFn) { callbackFn(null); }
                        that.hide();
                        el8.ptdata.ptProviders.load(null, true); // reload pt provider list
                    }
                });
            };

            var contact = el8.data.physicians.getById(contactId);
            el8.uiwidget.confirm(
                'This will remove "'+contact.getFullName()+
                    '" from your provider autocomplete and all patient provider teams. Continue?',
                deleteFn
            );

        }).on('change', ':input[name="acceptingInsurance"]',  function() {
            if (form.getVal('acceptingInsurance') === '1') {
                form.showField('insuranceAccepted');
            } else {
                form.hideField('insuranceAccepted');
            }

        });
    };

    var super_show = that.show;
    that.show = function(spec) {
        if (!spec) { return; }
        if (!spec.contactId && !spec.contactName) { return; }

        contactId = spec.contactId;
        callbackFn = spec.callbackFn || null;

        if (el8.app.shared.network.mappedProfileDetails.isOpen()) {
            // only one of these dialogs should be open at a time
            el8.app.shared.network.mappedProfileDetails.hide();
        }
        super_show.call(that);

        if (spec.contactId) {
            var contact = el8.data.physicians.getById(contactId);
            showIdSpecificElems();

            var soyMap = contact.asSoyMap();
            delete soyMap['specialties'];
            var isUserOwned = contact.getUserId() && contact.getUserId() !== el8Globals.USER_ID;
            $('.el8UnverifiedProfileSection').html(
                el8.template.app.shared.network.profileDetails.unmappedContentHeader({isUserOwned: isUserOwned})
            );
            if (isUserOwned) {
                form.getFieldNames().forEach(function(field) {
                    if (field !== 'notes') {
                        form.disableField(field);
                    }
                });
            }
            else {
                form.enable();
            }
            form.populate(soyMap);

            form.getListeditor('specialties').addEntries(contact.getSpecialties());
            if (contact.getContactType() === el8.util.consts.MEDICAL_GROUP_TYPE) {
                populateFullName(contact.getFullName());
            }
        } else if (spec.contactName) {
            hideIdSpecificElems();
            populateFullName(spec.contactName);
        }
        $('.trigger-section', that.getContentElt()).html(
            el8.template.app.shared.network.profileDetails.unmappedTriggerSection({connectionId: contactId})
        );
        el8.appchart.providers.tooltips.create(that.getContentElt());
        that.adjustPosition();
    };

    var super_hide = that.hide;
    that.hide = function() {
        el8.appchart.providers.tooltips.destroy(that.getContentElt());
        form.enableField('email');
        super_hide.call(that);
        contactId = null;
        callbackFn = null;

        // reset the type-specific fields
        $('.medical-group-block', that.getContentElt()).hide();
        $('.physician-block', that.getContentElt()).show();

        $(document).trigger('hide-unmapped-profile');
    };

    function saveFn() {
        var specialtyIds = _.pluck(form.getListeditor('specialties').getAllEntries(), 'id');
        if (specialtyIds.length && specialtyIds.indexOf(null) !== -1) {
            el8.uiwidget.alert('Please choose specialties from the autocomplete');
            return;
        }

        var postDict = getServerReadyFormMap();
        $.el8_ajax({
            url: el8.service.urls.get('connections', [contactId]),
            type: 'POST',
            data: JSON.stringify(postDict),
            success: function(data) {
                var connection = el8.data.physicians.create(data);
                if (contactId && el8.ptdata.ptProviders.getByPhysicianId(contactId)) {
                    // specialty category might have changed -> reload all providers
                    el8.ptdata.ptProviders.load(null, true);
                }
                if (callbackFn) { callbackFn(connection); }
                that.hide();
            }
        });
    }

    // Massage the output of the form so that we can submit it to the server
    function getServerReadyFormMap() {
        var postDict = form.getMapped(false, true);

        // remove non-digits from phone nums
        var phoneFields = ['phone', 'fax', 'cell_phone', 'back_office_phone'];
        phoneFields.forEach(function(fieldName) {
            postDict[fieldName] = el8.util.string.cleanPhoneNum(postDict[fieldName]);
        });

        // only submit the name fields relevant to this contact type
        if (postDict['contact_type'] === el8.util.consts.MEDICAL_GROUP_TYPE) {
            delete postDict['first_name'];
            delete postDict['middle_name'];
            delete postDict['last_name'];
        } else {
            delete postDict['name'];
        }

        // submit just the specialty_ids (not the whole object pulled out of the LE)
        var specialtyIds = _.pluck(form.getListeditor('specialties').getAllEntries(), 'id');
        postDict['specialty_ids'] = specialtyIds;
        delete postDict['specialties'];

        // convert acceptingInsurance / Patient ints to bools
        (['accepting_insurance', 'accepting_new_patients']).forEach(function(fieldName) {
            if (postDict[fieldName] === '1') {
                postDict[fieldName] = true;
            } else if (postDict[fieldName] === '0') {
                postDict[fieldName] = false;
            } else {
                postDict[fieldName] = null;
            }
        });
        if (!postDict['accepting_insurance']) {
            postDict['insurance_accepted'] = null; // clear the insurance textfield if insurance isn't accepted
        }

        return postDict;
    }

    // Switch between individual and organization contact type
    function showTypeSpecificFields() {
        var container = that.getContentElt();
        if (form.getVal('contactType') === el8.util.consts.MEDICAL_GROUP_TYPE) {
            $('.medical-group-block', container).show();
            $('.physician-block', container).hide();
        } else {
            $('.medical-group-block', container).hide();
            $('.physician-block', container).show();
        }
        that.adjustPosition();
    }

    // "id specific elems" are elements that should only show up if we're
    // editing an existing contact, rather than creating a new contact
    function showIdSpecificElems() {
        if (!contactId) { return; }

        var contact = el8.data.physicians.getById(contactId);
        var providerLogo = contact.getPublicAccessUserInfo().provider_logo;
        if (providerLogo === 'passport') {
            $('.passport-user-icon', that.getContentElt()).show();
        } else {
            $('.passport-user-icon', that.getContentElt()).hide();
        }
        if (contact.getAccessUserId()) {
            form.disableField('email'); // don't allow changing emails for passport contacts
        }
        $('.delete-trigger',that.getContentElt()).show();
    }
    function hideIdSpecificElems() {
        $('.passport-user-icon', that.getContentElt()).hide();
        $('.delete-trigger',that.getContentElt()).hide();
    }

    /**
     * Takes a fullName and tries to intelligently fill in firstName and lastName, when
     * those broken out fields are not available
     */
    function populateFullName(fullName) {
        if (el8.util.smart.isPhoneNum(fullName)) {
            form.setVal('fax', fullName);
            return;
        }
        form.setVal('name', fullName); // populate group name
        var names = fullName.split(' ');
        if (names[0].toLowerCase().startswith('dr')) { names = names.slice(1); }
        if (names.length === 1) {
            form.setVal('lastName', names[0]);
        } else if (names.length === 2) {
            form.setVal('firstName', names[0]);
            form.setVal('lastName', names[1]);
        } else if (names.length === 3) {
            form.setVal('firstName', names[0]);
            form.setVal('middleName', names[1]);
            form.setVal('lastName', names[2]);
        } else {
            form.setVal('firstName', names.slice(0, -2).join(' '));
            form.setVal('middleName', names.slice(-2, -1));
            form.setVal('lastName', names.slice(-1));
        }
    }


    return that;

})();
